"use client"

import { Card, CardContent, Box, Typography, IconButton } from "@mui/material"
import { Visibility, Download, Delete } from "@mui/icons-material"
import { styled } from "@mui/material/styles"
import { UrlApi } from "../../../../../../../services/apirest"

const ImageContainer = styled(Box)({
  position: "relative",
  paddingTop: "56.25%", // 16:9 aspect ratio
  overflow: "hidden",
  borderRadius: "4px",
})

const Image = styled("img")({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  objectFit: "cover",
  cursor: "pointer",
  transition: "transform 0.3s ease",
  "&:hover": {
    transform: "scale(1.05)",
  },
})

export default function ImageGalleryCard({ image, onView, onDownload, onDelete }) {
  const handleView = () => onView?.(image)
  const handleDownload = () => onDownload?.(image)
  const handleDelete = () => onDelete?.(image)
  const imageSrc = `${UrlApi}/uploadfiles/uploads/${image.id_archivo}-${image.nombre}`;

  return (
    <Card sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <ImageContainer>
        <Image src={imageSrc || "/placeholder.svg?height=200&width=300"} alt={image.nombre} onClick={handleView} />
      </ImageContainer>
      <CardContent sx={{ flexGrow: 1 }}>
        <Typography variant="subtitle2" gutterBottom>
          {image.nombre}
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          {image.descripcion}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {image.created_at}
        </Typography>
        <Box sx={{ mt: 2, display: "flex", gap: 1 }}>
          <IconButton size="small" onClick={handleView} title="Ver imagen">
            <Visibility />
          </IconButton>
          <IconButton size="small" onClick={handleDownload} title="Descargar">
            <Download />
          </IconButton>
          <IconButton size="small" color="error" onClick={handleDelete} title="Eliminar">
            <Delete />
          </IconButton>
        </Box>
      </CardContent>
    </Card>
  )
}
